import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../services/firebase';

function AdminRoute({ children }) {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingRole, setCheckingRole] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (!user) {
        setCheckingRole(false);
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          // Allow super_admin or club_admin
          const hasAdminRole = userData.role === 'super_admin' || userData.role === 'club_admin';
          setIsAdmin(hasAdminRole);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
      } finally {
        setCheckingRole(false);
      }
    };

    if (user) {
      checkAdminRole();
    } else if (!loading) {
      setCheckingRole(false);
    }
  }, [user, loading]);

  if (loading || checkingRole) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-content">
          <span className="loading-icon">⚽</span>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-content">
          <span className="loading-icon">🚫</span>
          <h2>Access Denied</h2>
          <p>You do not have admin privileges for this club.</p>
          <a href="/" className="btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
            Go Home
          </a>
        </div>
      </div>
    );
  }

  return children;
}

export default AdminRoute;
